import { createStandaloneToast } from '@chakra-ui/toast';
import { chakraTheme } from 'config/chakra';
import { addSeconds, format, parseISO } from 'date-fns';
import { ggSentry } from '../config/sentry';
import { PRODUCTION_MODE } from '../constants';
import { StorageService } from '../service/Storage';
import { isDev } from 'config';

export const isProdMode = StorageService.get(PRODUCTION_MODE) === true;

export const GOOGLE_RECAPTCHA_BASE_URL =
  'https://www.google.com/recaptcha/enterprise.js?render=';

export const RECAPTCHA_KEY = !isDev
  ? process.env.REACT_APP_RECAPTCHA_KEY_PROD
  : isProdMode
  ? process.env.REACT_APP_RECAPTCHA_KEY_PROD
  : process.env.REACT_APP_RECAPTCHA_KEY_DEV;
export async function loadScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
export function logout() {
  StorageService.setAccessToken();
  StorageService.setRefreshToken();
  StorageService.setWId();
  StorageService.setXPN();
  StorageService.setUserId();
  StorageService.setMobile();
}
const toast = createStandaloneToast({ theme: chakraTheme });

/**
 * @param {Promise<any> | (() => Promise<any>)} fn Async Function or Promise
 * @param {Boolean | string} successMsg  Default is `false`. Set `true` for default message or pass custom string msg.
 * @param {Boolean | string} errorMsg  Default is `true`. Set `true` for default message or pass custom string msg.
 * @param {Boolean} propagateError  Default is `true`. Set `false` to stop propagate Error from this function
 */
export const withDefaultUIHandler = async (
  fn,
  successMsg = false,
  errorMsg = true,
  propagateError = true
) => {
  try {
    const data = await (fn.then ? fn : fn());
    if (successMsg) {
      //@todo
    }
    return data;
  } catch (error) {
    if (
      error?.response?.err_code === 1003 ||
      error?.response?.err_code === 1004 ||
      error?.data?.err_code === 1003 ||
      error?.data?.err_code === 1004
    ) {
      throw error;
    }
    ggSentry.catchExceptions(error);
    if (errorMsg !== false) {
      console.error(errorMsg === true ? formatServerErrors(error) : error);
      toast({
        title: errorMsg === true ? formatServerErrors(error) : error,
        status: 'error',
        isClosable: true,
      });
    }
    if (propagateError) {
      throw error;
    }
  }
};

export function formatServerErrors(error) {
  const serverErrorMsg =
    error?.response?.data?.error || error?.response?.data?.err;

  if (serverErrorMsg && typeof serverErrorMsg === 'string') {
    return [serverErrorMsg];
  }

  if (error?.response) {
    const responseData = error.response.data;
    const statusCode = error.response.status;

    if (statusCode === 503 || statusCode === 502) {
      return ['Service down. Please try again.'];
    }
    if ([413].includes(statusCode)) {
      return [`The file you are trying to upload is too large`];
    }
    if (responseData && typeof responseData === 'string') {
      return [responseData];
    }
    if ([404, 400, 500, 501, 405].includes(statusCode)) {
      return ['Some error occurred, please try again'];
    }

    if ([403, 401].includes(statusCode)) {
      return [`Forbidden. You're not allowed to perform the action`];
    }

    if (typeof responseData === 'string' && responseData.includes('Network')) {
      //"Network Error caught"
      if (window.navigator.onLine) {
        return ['Server Error'];
      }
      return ['Network Error or Service down'];
    }

    return ['Some error occurred, please try again'];
  }

  if (error.message && typeof error.message === 'string') {
    return !window.navigator.onLine
      ? ['No active internet connection!']
      : [error.message];
  }

  return ['Some error occurred, please try again'];
}

export function paisaToRupee(paisa) {
  if (!paisa) return 0;
  return Number(paisa / 100).toFixed(2);
}

export const calculatePercentage = (current, base) => {
  const value = (Number(current) / Number(base)) * 100;
  if (isNaN(value)) {
    return 0;
  } else if (value === Infinity) {
    return 0;
  } else {
    return +Number(value).toFixed(2);
  }
};

export function formatNumber(number) {
  return new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(
    number
  );
}

formatNumber(1970.5);

export function formattedTime(seconds) {
  var helperDate = addSeconds(new Date(0), seconds);
  return format(helperDate, 'mm:ss');
}

export const secondsToMinutes = seconds =>
  Math.floor(seconds / 60) + ':' + ('0' + Math.floor(seconds % 60)).slice(-2);

export async function copyToClickBoard(str) {
  str = String(str);
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(str);
      return true;
    } else {
      const input = document.createElement('input');
      input.style = 'position: absolute; z-index: 100000000;  top: 0';
      input.value = str;
      document.body.append(input);
      input.focus();
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      return true;
    }
  } catch (error) {
    console.log('Error', error);
    return false;
  }
}

export function secondsToHms(d) {
  d = Number(d);
  var hour = Math.floor(d / 3600);
  var minutes = Math.floor((d % 3600) / 60);
  var seconds = Math.floor((d % 3600) % 60);

  return {
    hour,
    minutes,
    seconds,
  };
}
export async function downloadApk(fileName = 'ChillarPRO.apk') {
  try {
    await downloadLink(process.env.REACT_APP_SIKKA_APK_DOWNLOAD_URL, fileName);
  } catch (error) {
    console.log('error', error);
  }
}
function downloadLink(url, filename = 'ChillarPRO.apk') {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
}

export function currencyValue(SikkaValue) {
  return StorageService.getCurrency() === 'inr'
    ? (SikkaValue / 10).toFixed(2)
    : SikkaValue;
}
